<template>
	<div>
		<el-date-picker style="margin-left: 8px;" v-model="selectTime" type="daterange" align="right" unlink-panels
			range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
			:picker-options="pickerOptions">
		</el-date-picker>
	</div>
</template>

<script>
	import {
		searchTime,
		
	} from 'network/hk_operset'
	import {
		getThisYear,
	}  from "../js/billet.js"
	export default {
		name: 'timesel',
		data() {
			return {
				selectTime: [],
				pickerOptions: '',
			}
		},
		watch: {
			selectTime() {
				this.getTimes()
			},
		},
		methods: {
			getTimes() {
				let result = []
				if (this.selectTime && this.selectTime.length) {
					let timestamp1 = (this.selectTime[0] + '')
					let timestamp2 = (this.selectTime[1] + '')
					result.push(timestamp1.slice(0, 10) * 1)
					result.push(timestamp2.slice(0, 10) * 1)
					result = JSON.stringify(result)
				} else {
					result = getThisYear()
				}
				this.$emit('transTime', {
					result,
				})
			},

		},
		created() {
			this.pickerOptions = searchTime()
		},
	}

</script>

<style lang="scss" scoped>
	
</style>
